export default __webpack_public_path__ + "73b3a8d438dcecf18aa0f0b2c260e238.png";